module.exports = __webpack_public_path__ + "img/031.8b0af82a.jpg";